/**
 * TAIC · 指南页导购模块（2026-09-15 转化诊断 P0-2）
 *
 * 背景：指南/内容页拿走约 57% 的自然点击，但页内没有任何商品卡片入口，
 *       仅有正文中后段的文字链接，读者读完即流失。
 *
 * 做法：正文里只放一段可被抓取的降级链接列表（<a href="/products/...">），
 *       本脚本在运行时把它增强成带图、带实时价格的商品卡。
 *       JS 失效时链接依然可点、依然可被搜索引擎抓到，不影响 SEO。
 */
(function () {
  'use strict';

  var ROOT = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';

  function money(cents) {
    var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'US $' + n;
  }

  function imgUrl(src, width) {
    if (!src) return '';
    return src.replace(/(\.(?:jpe?g|png|webp|gif))(\?.*)?$/i, '_' + width + 'x$1$2');
  }

  function card(p) {
    var el = document.createElement('a');
    el.className = 'taic-pick';
    el.href = ROOT.replace(/\/$/, '') + '/products/' + p.handle;

    var media = document.createElement('span');
    media.className = 'taic-pick__media';
    if (p.featured_image) {
      var img = document.createElement('img');
      img.src = imgUrl(p.featured_image, 480);
      img.alt = p.title;
      img.loading = 'lazy';
      img.width = 480;
      img.height = 480;
      media.appendChild(img);
    }

    var body = document.createElement('span');
    body.className = 'taic-pick__body';

    var title = document.createElement('span');
    title.className = 'taic-pick__title';
    title.textContent = p.title;

    var price = document.createElement('span');
    price.className = 'taic-pick__price';
    price.textContent = p.available ? money(p.price) : 'Sold out';

    var cta = document.createElement('span');
    cta.className = 'taic-pick__cta';
    cta.textContent = p.variants && p.variants.length > 1 ? 'Choose options' : 'View product';

    body.appendChild(title);
    body.appendChild(price);
    body.appendChild(cta);
    el.appendChild(media);
    el.appendChild(body);
    return el;
  }

  /**
   * 标签写在正文 HTML 里（英文，供抓取），运行时按当前语种替换。
   * 文案来自 locales/*.json 的 taic.picks_label，由 theme.liquid 输出到 window.TAIC_I18N。
   */
  function localizeLabel(block) {
    var i18n = window.TAIC_I18N || {};
    if (!i18n.picksLabel) return;
    var el = block.querySelector('.taic-picks__label');
    if (el && el.textContent.trim() !== i18n.picksLabel) {
      el.textContent = i18n.picksLabel;
    }
  }

  function enhance(block) {
    localizeLabel(block);

    var handles = (block.getAttribute('data-taic-picks') || '')
      .split(',')
      .map(function (h) { return h.trim(); })
      .filter(Boolean);
    if (!handles.length) return;

    Promise.all(
      handles.map(function (h) {
        return fetch(ROOT.replace(/\/$/, '') + '/products/' + h + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (products) {
      var found = products.filter(Boolean);
      // 一个都没取到就保留降级链接，不动它
      if (!found.length) return;

      var grid = document.createElement('div');
      grid.className = 'taic-picks__grid';
      found.forEach(function (p) { grid.appendChild(card(p)); });

      var fallback = block.querySelector('.taic-picks__fallback');
      if (fallback) {
        fallback.parentNode.replaceChild(grid, fallback);
      } else {
        block.appendChild(grid);
      }
      block.classList.add('taic-picks--ready');
    });
  }

  function init() {
    var blocks = document.querySelectorAll('[data-taic-picks]');
    for (var i = 0; i < blocks.length; i++) enhance(blocks[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
